const videos = [
  {
    title: '某顶流深夜密会神秘女子，酒店同框照曝光引热议',
    duration: '03:25',
    views: '128w',
    img: 'https://readdy.ai/api/search-image?query=Modern%20entertainment%20news%20studio%20scene%20with%20vibrant%20warm%20lighting%2C%20abstract%20media%20visual%20with%20play%20button%20design%2C%20soft%20coral%20and%20gold%20accents%2C%20clean%20minimal%20background%2C%20editorial%20broadcast%20style%2C%20professional%20video%20production%20aesthetic&width=640&height=400&seq=media-thumb-01&orientation=landscape'
  },
  {
    title: '网红主播直播翻车现场，千万粉丝围观名场面',
    duration: '05:12',
    views: '96w',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20live%20streaming%20studio%20setup%20with%20warm%20atmospheric%20lighting%2C%20modern%20broadcast%20equipment%2C%20vibrant%20coral%20and%20amber%20color%20scheme%2C%20clean%20minimal%20background%2C%20professional%20streaming%20production%20aesthetic&width=640&height=400&seq=media-thumb-02&orientation=landscape'
  },
  {
    title: '独家深扒：某选秀节目黑幕全记录，导师团内讧细节流出',
    duration: '08:47',
    views: '215w',
    img: 'https://readdy.ai/api/search-image?query=Talent%20show%20stage%20with%20dramatic%20spotlight%20and%20warm%20golden%20glow%2C%20entertainment%20production%20scene%2C%20vibrant%20atmosphere%2C%20theatrical%20lighting%20with%20coral%20and%20amber%20tones%2C%20clean%20composition%2C%20editorial%20style&width=640&height=400&seq=media-thumb-03&orientation=landscape'
  },
  {
    title: '年度最大瓜回顾：那些年我们一起追过的热门事件',
    duration: '12:30',
    views: '189w',
    img: 'https://readdy.ai/api/search-image?query=Retrospective%20collage%20of%20entertainment%20news%20headlines%20and%20social%20media%20icons%2C%20warm%20nostalgic%20lighting%2C%20coral%20pink%20and%20gold%20tones%2C%20clean%20minimal%20background%2C%20editorial%20magazine%20year%20review%20style&width=640&height=400&seq=media-thumb-04&orientation=landscape'
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-12">
          <span className="inline-block text-xs font-label tracking-wider text-primary-600 bg-primary-100 px-4 py-1.5 rounded-full mb-4 whitespace-nowrap">
            视频
          </span>
          <h2 className="font-heading text-[32px] md:text-[40px] text-foreground-950">独家视频</h2>
          <p className="text-sm text-foreground-500 mt-3">精选全网最具话题性的吃瓜视频，随时随地追瓜不停</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {videos.map((video, i) => (
            <div key={i} className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:shadow-lg transition-all duration-300 cursor-pointer">
              <div className="relative aspect-[16/10] overflow-hidden bg-secondary-200">
                <img
                  src={video.img}
                  alt={video.title}
                  title={`51吃瓜网 ${video.title.substring(0, 20)}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-background-50/80 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                    <i className="ri-play-fill text-2xl md:text-3xl ml-1"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 bg-foreground-900/75 text-background-50 text-xs px-2 py-1 rounded-md whitespace-nowrap">
                  {video.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-[15px] text-foreground-900 leading-snug line-clamp-2 mb-3 group-hover:text-primary-600 transition-colors">
                  {video.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>{video.views}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>2小时前
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}